<template>
    <!--    <c-dialog ref="dialog" height="350" width="450" :button="!cardNoEditabled" @resolve="editHandle">-->
    <c-dialog ref="dialog" :height="dialogHeight" width="450" @resolve="editHandle">
        <c-form ref="form" unit-width="100%">
            <!--企业账户可选绑个人卡/对公卡，个人账户固定绑个人卡-->
            <c-form-item label="卡类型" v-if="isCompany" required>
                <c-radio-group name="card_pro" :options="cardProOptions" v-model="card_pro"></c-radio-group>
            </c-form-item>
            <!--个人卡：验证码绑卡（原流程不变）-->
            <template v-if="card_pro != 2">
                <c-form-item label="持卡人姓名">
                    <c-input name="name" disabled></c-input>
                </c-form-item>
                <c-form-item label="手机号">
                    <c-input name="phone" maxlength="50" v-model="phone"></c-input>
                </c-form-item>
                <c-form-item label="银行卡号" required>
                    <c-input name="bank_card_no" v-model="bank_card_no" maxlength="50" :disabled="!cardNoEditabled">
                    </c-input>
                </c-form-item>
            </template>
            <!--对公卡：企业对公账户绑卡（无需验证码，接口成功直接绑定）-->
            <template v-if="card_pro == 2">
                <!--对公卡绑定后提现收款账户变更，需重新签订提现协议-->
                <p class="m-company-tip">绑定新的对公卡后，之前已签订的提现协议将失效，需要重新签订</p>
                <c-form-item label="对公账户" required>
                    <c-input name="account_no" v-model="account_no" maxlength="50"></c-input>
                </c-form-item>
                <c-form-item label="开户银行名称" required>
                    <c-input name="parent_bank_name" v-model="parent_bank_name" maxlength="50"></c-input>
                </c-form-item>
                <c-form-item label="开户行支行名称" required>
                    <c-input name="bank_name" v-model="bank_name" maxlength="50"></c-input>
                </c-form-item>
                <c-form-item label="支付行号" required tip="开户支行对应的12位支付行号">
                    <c-input name="union_bank" v-model="union_bank" maxlength="12"></c-input>
                </c-form-item>
            </template>
        </c-form>
    </c-dialog>
</template>

<script>

export default {
    name:'allinpay_bind_phone',
    data() {
        return {
            cardNoEditabled:true,       //是否还允许修改卡号
            userId:0,
            member_type:3,              //会员类型（2=企业账户，可选绑对公卡）
            card_pro:1,                 //卡类型 1=个人卡 2=对公卡
            cardProOptions: [
                {name:'个人卡',value:1},
                {name:'对公卡',value:2}
            ],
            bank_card_no:'',
            phone: '',
            verify_code: '',
            countdown: false,
            bankcard_id:0,
            account_no:'',              //企业对公账户
            parent_bank_name:'',        //开户银行名称
            bank_name:'',               //开户行支行名称
            union_bank:''               //支付行号
        }
    },
    computed: {
        countdownText() {
            return this.countdown ? `(${this.countdown})` : this.countdown === 0 ? '重新获取' : '获取验证码';
        },
        /******是否企业账户（可选绑对公卡）******/
        isCompany() {
            return this.member_type == 2;
        },
        /******弹窗高度自适应卡类型******/
        dialogHeight() {
            if (!this.isCompany) return 350;
            return this.card_pro == 2 ? 500 : 420;
        }
    },
    mounted() {
        this.countdown = false;
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(member_id) {
            this.cardNoEditabled = true;
            this.bank_card_no = '';
            this.bankcard_id = 0;
            this.verify_code = '';
            this.account_no = '';
            this.parent_bank_name = '';
            this.bank_name = '';
            this.union_bank = '';
            this.$refs.form.clear();
            //clear 会同步清空表单绑定的 v-model，重置默认卡类型：个人卡
            this.card_pro = 1;
            this.member_type = 3;
            if (member_id) {
                this.getMemberDetail(member_id);
            }
            //填充form表单
            this.$refs.dialog.open({
                title: '提现银行卡绑定'
            });
        },
        /**
         * 查询会员详情
         */
        getMemberDetail(member_id){
            //调用发送短信接口
            this.request({
                url: '/financial/member/detail',
                data: {
                    member_id:member_id,
                },
                loading: true,
                success: data => {
                    this.$refs.form.set(data);
                    this.phone = data.phone;
                    this.userId = data.user_id;
                    //企业账户（2）绑卡时可选择个人卡/对公卡
                    this.member_type = data.member_type || 3;
                }
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle(stop, next) {
            stop();

            if (!this.phone) {
                this.$message({
                    message: '手机号信息异常，无法创建账号'
                });
                return;
            }
            if (!this.bank_card_no) {
                this.$message({
                    message: '请输入需要绑卡银行卡号'
                });
                return;
            }
            this.request({
                url: '/allinpay/bind/bankcard/apply/new',
                data: {
                    client_user_id:this.userId,
                    phone:this.phone,
                    bank_card_no:this.bank_card_no
                },
                success: data => {
                    next();
                    this.$message({
                        message: '绑卡成功'
                    });
                    this.$emit('resolve');
                },
                fail: (code, data, msg) => {
                    this.$confirm({
                        message: msg,
                        buttonName: '我知道了',
                        cancelButton: false,
                        resolve: () => {
                        }
                    })
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.m-company-tip {
    margin: 0 0 12px;
    padding: 8px 12px;
    font-size: 14px;
    line-height: 18px;
    color: red;
    background: rgba(250, 140, 22, 0.08);
    border-radius: 4px;
}

.smscode {
    display: block;
    margin-top: 9px;
    margin-right: 8px;
    line-height: 20px;
    font-size: 12px;
    color: var(--color-main);

    &.z-dis {
        color: #999;
    }
}
</style>